import React from 'react';
import { Button, Input } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from '@plone/volto/components';
import loupeSVG from '@plone/volto/icons/zoom.svg';
import clearSVG from '@plone/volto/icons/clear.svg';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
});

const SearchInput = (props) => {
  const {
    data,
    searchText,
    setSearchText,
    isLive,
    onTriggerSearch,
    removeSearchQuery,
  } = props;
  const intl = useIntl();

  return (
    <div className="search-input">
      <Input
        id={`${props.id}-searchtext`}
        value={searchText}
        placeholder={
          data.searchInputPrompt || intl.formatMessage(messages.search)
        }
        fluid
        onKeyPress={(event) => {
          // Note, do NOT use isLive as a trigger condition here, because this would
          // always trigger an initial request with the OLD term. In fact, onChange
          // will trigger a request with the NEW term, so we only have to react to
          // the Enter key here.
          if (event.key === 'Enter') {
            onTriggerSearch(searchText);
          }
        }}
        onChange={(event, { value }) => {
          setSearchText(value);
          if (isLive) {
            onTriggerSearch(value);
          }
        }}
        aria-label="Search"
      />
      {searchText && (
        <Button
          basic
          icon
          className="search-input-clear-icon-button"
          onClick={() => {
            setSearchText('');
            /* START CUSTOMIZATION */
            removeSearchQuery();
            /* END CUSTOMIZATION */
          }}
        >
          <Icon name={clearSVG} />
        </Button>
      )}
      {isLive && !searchText && (
        <Button
          basic
          icon
          className="search-input-live-icon-button"
          aria-label="Search"
        >
          <Icon name={loupeSVG} />
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
